export const dateToAttrValue = (date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};
export const attrValueToDate = (value) => {
    if (!value) {
        return new Date();
    }
    const [year, month, day] = value.split("-");
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};
export const formatDateValue = (value) => {
    return attrValueToDate(value).toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
};
